const LoadingSkeletonHaggleForm = () => {
	return (
		<div
			className=" mx-auto bg-white p-6 rounded-lg shadow-md w-full"
			data-test="loading-haggle-form"
		>
			<h3 className="font-bold text-xl uppercase text-center mb-6">
				<div className="bg-gray-200 h-8 w-1/3 mx-auto rounded animate-pulse"></div>
			</h3>
			<div className="flex flex-wrap gap-4 justify-between w-full">
				<div className="flex flex-col w-full md:w-[48%] space-y-4">
					<div className="h-11 bg-gray-200 rounded animate-pulse"></div>
					<div className="h-11 bg-gray-200 rounded animate-pulse"></div>
					<div className="h-11 bg-gray-200 rounded animate-pulse"></div>
				</div>
				<div className="w-full md:w-[48%]">
					<div className="h-40 bg-gray-200 rounded animate-pulse"></div>
				</div>
				<div className="border-t w-full my-4"></div>
				<div className="w-full h-12 bg-gray-200 rounded animate-pulse"></div>
			</div>
		</div>
	);
};

export default LoadingSkeletonHaggleForm;
